var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _templateObject = _taggedTemplateLiteralLoose(["\n    min-height: ", "px;\n  "], ["\n    min-height: ", "px;\n  "]),
    _templateObject2 = _taggedTemplateLiteralLoose(["\n    min-height: ", "px;\n    align-items: flex-start;\n  "], ["\n    min-height: ", "px;\n    align-items: flex-start;\n  "]),
    _templateObject3 = _taggedTemplateLiteralLoose(["\n    botttom: 0px;\n    border-bottom: 200px solid #faa5aa;\n    border-right: 0px solid transparent;\n    border-left: 630px solid transparent;\n  "], ["\n    botttom: 0px;\n    border-bottom: 200px solid #faa5aa;\n    border-right: 0px solid transparent;\n    border-left: 630px solid transparent;\n  "]);

function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }

import React, { Fragment } from "react";
import Menu from "./Menu";
import styled, { css, ThemeProvider } from "styled-components";
import Heading from "../components/Heading";
import { media } from "../index";

var HeadingSpace = styled.div.withConfig({
  displayName: "MenuWithHeader__HeadingSpace",
  componentId: "sc-17w8ut9-0"
})(["position:relative;background-color:", ";width:100%;min-height:", "px;", ";", ";"], function (props) {
  return props.theme.background;
}, function (props) {
  return props.headingHeight;
}, media.desktop(_templateObject, function (props) {
  return props.headingHeight;
}), function (props) {
  return props.bgImage && css(["background-image:url('", "');background-repeat:", ";background-size:", ";background-position:", ";"], function (props) {
    return props.bgImage;
  }, function (props) {
    return props.bgImageConfig.repeat || "no-repeat";
  }, function (props) {
    return props.bgImageConfig.size || "cover";
  }, function (props) {
    return props.bgImageConfig.position || "top center";
  });
});

var HeadingTitle = styled.div.withConfig({
  displayName: "MenuWithHeader__HeadingTitle",
  componentId: "sc-17w8ut9-1"
})(["min-height:", "px;", " max-width:", ";margin:0 auto;display:flex;flex-direction:column;align-items:center;justify-content:flex-end;padding:0 1.5em;"], function (props) {
  return props.headingHeight;
}, media.desktop(_templateObject2, function (props) {
  return props.headingHeight;
}), function (props) {
  return props.theme.width;
});

var HeadingEdge = styled.div.withConfig({
  displayName: "MenuWithHeader__HeadingEdge",
  componentId: "sc-17w8ut9-2"
})(["right:0px;position:absolute;bottom:0px;border-bottom:80px solid #faa5aa;border-right:0px solid transparent;border-left:230px solid transparent;", ";"], media.desktop(_templateObject3));

var MenuWithHeader = function MenuWithHeader(_ref) {
  var children = _ref.children,
      theme = _ref.theme,
      menuProps = _ref.menuProps,
      bgImage = _ref.bgImage,
      _ref$bgImageConfig = _ref.bgImageConfig,
      bgImageConfig = _ref$bgImageConfig === undefined ? {} : _ref$bgImageConfig,
      heading = _ref.heading,
      _ref$headingHeight = _ref.headingHeight,
      headingHeight = _ref$headingHeight === undefined ? 300 : _ref$headingHeight,
      headingChildren = _ref.headingChildren,
      edge = _ref.edge;

  var result = React.createElement(
    Fragment,
    null,
    React.createElement(
      Menu,
      _extends({ positionAbsolute: true }, menuProps),
      children
    ),
    React.createElement(
      HeadingSpace,
      {
        className: "heading_space",
        headingHeight: headingHeight,
        bgImage: bgImage,
        bgImageConfig: bgImageConfig
      },
      headingChildren || React.createElement(
        HeadingTitle,
        { headingHeight: headingHeight },
        React.createElement(
          Heading,
          { style: { zIndex: 2 } },
          heading
        )
      ),
      edge && React.createElement(HeadingEdge, null)
    )
  );

  if (theme) {
    return React.createElement(
      ThemeProvider,
      { theme: theme },
      result
    );
  }
  return result;
};

MenuWithHeader.HeadingSpace = HeadingSpace;
MenuWithHeader.HeadingTitle = HeadingTitle;

export default MenuWithHeader;